/* tslint:disable */
/* eslint-disable */
/**
 * Mclarens.OutlookAddin.Api.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BillingRole } from './BillingRole';
import {
    BillingRoleFromJSON,
    BillingRoleFromJSONTyped,
    BillingRoleToJSON,
} from './BillingRole';

/**
 * 
 * @export
 * @interface BillingRolesResponse
 */
export interface BillingRolesResponse {
    /**
     * 
     * @type {string}
     * @memberof BillingRolesResponse
     */
    claimNumber: string;
    /**
     * 
     * @type {string}
     * @memberof BillingRolesResponse
     */
    projectId: string;
    /**
     * 
     * @type {string}
     * @memberof BillingRolesResponse
     */
    timesheetId: string;
    /**
     * 
     * @type {Date}
     * @memberof BillingRolesResponse
     */
    date: Date;
    /**
     * 
     * @type {Array<BillingRole>}
     * @memberof BillingRolesResponse
     */
    billingRoles: Array<BillingRole>;
    /**
     * 
     * @type {any}
     * @memberof BillingRolesResponse
     */
    count: any | null;
}

/**
 * Check if a given object implements the BillingRolesResponse interface.
 */
export function instanceOfBillingRolesResponse(value: object): value is BillingRolesResponse {
    if (!('claimNumber' in value) || value['claimNumber'] === undefined) return false;
    if (!('projectId' in value) || value['projectId'] === undefined) return false;
    if (!('timesheetId' in value) || value['timesheetId'] === undefined) return false;
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('billingRoles' in value) || value['billingRoles'] === undefined) return false;
    if (!('count' in value) || value['count'] === undefined) return false;
    return true;
}

export function BillingRolesResponseFromJSON(json: any): BillingRolesResponse {
    return BillingRolesResponseFromJSONTyped(json, false);
}

export function BillingRolesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillingRolesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'claimNumber': json['claimNumber'],
        'projectId': json['projectId'],
        'timesheetId': json['timesheetId'],
        'date': (new Date(json['date'])),
        'billingRoles': ((json['billingRoles'] as Array<any>).map(BillingRoleFromJSON)),
        'count': json['count'],
    };
}

export function BillingRolesResponseToJSON(value?: BillingRolesResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'claimNumber': value['claimNumber'],
        'projectId': value['projectId'],
        'timesheetId': value['timesheetId'],
        'date': ((value['date']).toISOString().substring(0,10)),
        'billingRoles': ((value['billingRoles'] as Array<any>).map(BillingRoleToJSON)),
        'count': value['count'],
    };
}

